import React, { useState, useRef, useEffect } from 'react';
import {Link} from 'react-router-dom';
import Slideshow from '../components/type2-slider.js'
import SearchIcon from '../svgs/search';
import DownArrow from '../svgs/down-arrow';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import '../styles/sections/heroQuoteSection.scss';

function HeroQuoteSection(props) {
    const data = props.data;
    const serviceId = props.serviceCat;

    const [services, showServices] = useState("");
    const [maxHeight, setmaxHeight] = useState("0px");
    const servicesList = useRef(null);

    const servicesArr = require('../jsons/quote-service-options').default;
    var quoteServices = servicesArr[serviceId];
    const servicesToggle = () => {
        showServices(services === "" ? "active": "");
        setmaxHeight(services === "active" ? "0px" : `${servicesList.current.scrollHeight}px`);
    }
    const closeQuoteListingOnOutsideClick = (e) => {
        var quoteListing = document.getElementsByClassName('quoteListing')[0];
        if(e.target !== quoteListing && e.target.parentNode !==quoteListing){
            showServices("");
            setmaxHeight("0px");
        }
    }

    useEffect(() =>{
        document.body.addEventListener('click', closeQuoteListingOnOutsideClick);
        return () =>{
            document.body.removeEventListener('click', closeQuoteListingOnOutsideClick);
        }
    });
    return (
        <div className="heroQuoteSection"> 
            <div className="imageContainer" style={{ textAlign: data.position}}>      
                <div className={data.class}>
                    {data.slider &&
                        <Slideshow data={data.slider} />
                    }
                    <LazyLoadImage 
                    effect="blur"
                    src={data.image} 
                    alt={data.title}
                    />
                </div>          
                
            </div>
            <div className="contentSection">
                <h1>{ data.title }</h1>
                <div className="headline" dangerouslySetInnerHTML={{ __html: data.headline }} />
                <div className="getQuote">
                    <div className="quoteListing">
                        <h6 onClick={servicesToggle} className={services}>
                        <span className="search-icon"><SearchIcon /></span>
                        WHAT ARE YOU LOOKING FOR?
                        <span className="down-arrow"><DownArrow /></span>
                        </h6>
                        {quoteServices && 
                            <ul className="tac" ref={servicesList} style={{ maxHeight: `${maxHeight}`}}>
                                {quoteServices.map((d,i)=>
                                    <li key={i}><Link to={`/get-quote?s=${serviceId}&sc=${d}`}>{d}</Link></li>
                                )}                                
                            </ul>
                        }                        
                    </div>
                    <a className={`btn pill quote grad-${data.btnGrad}`} href="/"> GET A QUOTE</a>
                </div>
            </div>
        </div>
    )
};

export default HeroQuoteSection; 